import React, { FC } from 'react';
import Lozenge, { ThemeAppearance } from '@atlaskit/lozenge';
import { TeamInputAtlassianOrgStatusEnum } from '@atlassiansox/phobos-client-ts';

import { testIds } from './constants';

type TeamOrgStatusProps = {
  orgStatus: TeamInputAtlassianOrgStatusEnum;
};

const TeamOrgStatus: FC<TeamOrgStatusProps> = ({ orgStatus }) => {
  let appearance: ThemeAppearance;
  let isBold: boolean = false;
  let displayStatus: string = orgStatus.toString();

  switch (orgStatus) {
    case TeamInputAtlassianOrgStatusEnum.Assigned:
      appearance = 'moved';
      displayStatus = 'to be verified';
      break;
    case TeamInputAtlassianOrgStatusEnum.Verified:
      appearance = 'success';
      isBold = true;
      break;
    case TeamInputAtlassianOrgStatusEnum.Unassigned:
      appearance = 'moved';
      break;
  }

  // Not even having the org status value
  if (!orgStatus || orgStatus === TeamInputAtlassianOrgStatusEnum.Unassigned) return <></>;

  return (
    <Lozenge isBold={isBold} appearance={appearance} testId={testIds.teamOrgStatus}>
      {displayStatus}
    </Lozenge>
  );
};

export default TeamOrgStatus;
